<ng-container *ngrxLet="activeUser$ as activeUser">
  <div class="special-request-wrapper">
    <app-callout message="{{activeUser.isCustomer() ? 'For this unique request, our team of expert will reach out to you to understand your specific requirements'
      : 'This is a special request, please reach out to client to better understand their specific needs.'}}"
                 appearance="new-light">
    </app-callout>
  </div>
</ng-container>

